import { Grid, makeStyles } from '@material-ui/core';
import {
  ActivityFilterOptions,
  ActivityFilters,
  ActivityStatus,
} from '../../api/types';
import { FilterSelect } from './ActivityFiltersPanelControls';

const useStyles = makeStyles({ controls: { alignItems: 'center' } });

export interface SelectOption {
  value: string;
  label: string;
}

export interface FilterControlsProps {
  filters: ActivityFilters;
  options: ActivityFilterOptions;
  loadingOptions: boolean;
  getProjectLabel: (projectId: string) => string;
  getCreatorLabel: (creatorRef: string) => string;
  onFiltersChange: (patch: Partial<ActivityFilters>) => void;
}

interface FilterDefinition {
  id: string;
  label: string;
  value?: string;
  options: SelectOption[];
  allLabel: string;
  disabled?: boolean;
  onChange: (value: string | undefined) => void;
}

const STATUS_OPTIONS: SelectOption[] = [
  { value: 'preparing', label: 'Preparando' },
  { value: 'active', label: 'Ativa' },
  { value: 'completed', label: 'Concluída' },
  { value: 'error', label: 'Erro' },
];

function fixedDefinitions(props: FilterControlsProps): FilterDefinition[] {
  return [
    {
      id: 'filter-status',
      label: 'Status',
      value: props.filters.status,
      options: STATUS_OPTIONS,
      allLabel: 'Todos',
      onChange: status =>
        props.onFiltersChange({ status: status as ActivityStatus | undefined }),
    },
  ];
}

function contextualDefinitions(props: FilterControlsProps): FilterDefinition[] {
  return [
    {
      id: 'filter-project',
      label: 'Projeto',
      value: props.filters.azureProject,
      options: props.options.projects.map(value => ({
        value,
        label: props.getProjectLabel(value),
      })),
      allLabel: 'Todos',
      disabled: props.loadingOptions && props.options.projects.length === 0,
      onChange: azureProject =>
        props.onFiltersChange({ azureProject, azureRepository: undefined }),
    },
    {
      id: 'filter-repository',
      label: 'Repositório',
      value: props.filters.azureRepository,
      options: props.options.repositories.map(value => ({
        value,
        label: value,
      })),
      allLabel: 'Todos',
      disabled: props.loadingOptions || props.options.repositories.length === 0,
      onChange: azureRepository => props.onFiltersChange({ azureRepository }),
    },
  ];
}

export const PrimaryFilters = (props: FilterControlsProps) => {
  const classes = useStyles();
  const [statusDefinition] = fixedDefinitions(props);
  const definitions = [statusDefinition, ...contextualDefinitions(props)];
  return (
    <Grid container spacing={2} className={classes.controls}>
      {definitions.map(definition => (
        <Grid item xs={12} sm={6} md={3} key={definition.id}>
          <FilterSelect {...definition} />
        </Grid>
      ))}
    </Grid>
  );
};
